import { jsx as _jsx } from "preact/jsx-runtime";
import styles from './styles/ModalHeaderWrapper.module.scss';
const ModalHeaderWrapper = ({ children }) => {
    return _jsx("div", Object.assign({ class: styles.modalHeaderWrapper }, { children: children }), void 0);
};
export default ModalHeaderWrapper;
